import React, { Component } from 'react';
// Externals
import compose from 'recompose/compose';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import { withRouter } from 'react-router-dom';
import EventsTable from '../../EventsObjective/EventsObjectiveTableLight';
//import {getDetalleDisponibilidadGlobalObjetivoDowntimeCustom} from '../../../../../services/getDetalleDisponibilidadGlobalObjetivoDowntimeC'
//import {getDetalleDisponibilidadGlobalObjetivoDowntime} from '../../../../../services/getDetalleDisponibilidadGlobalObjetivoDowntime'
//import {getDetalleDisponibilidadParcialObjetivoDowntime} from '../../../../../services/getDetalleDisponibilidadParcialObjetivoDowntime'
import {getDetalleDisponibilidadConsolidada} from '../../../../../services/getDetalleDisponibilidadConsolidada'
import {getDetalleDisponibilidadConsolidadaCustom} from '../../../../../services/getDetalleDisponibilidadConsolidadaCustom'
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

highchartsMore(Highcharts);
xRange(Highcharts);
Highcharts.setOptions({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miércoles',
            'Jueves', 'Viernes', 'Sábado'
        ],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    }
});
class AvailabilityConsolidatedSimplified extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.params.objective.objetivo_id,
            prevObjectiveId: this.props.params.objective.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptionsStackedBarConsolidated: this._chartOptionsBase,
            chartOptionsStackedBarNode: this._chartOptionsBase,
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            modalOpen: false,
            modalClose : true, 
            point: [],
            monitores: [],
            schedule:0,
        }
    }
    _chartOptionsBase = {
        chart: {
            type: 'xrange'
        },
        title: {
            text: ""
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: '',
                fontSize: '',
            }
        },
        
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,//set to true
                // align: 'left',
                style:{
                    // width:'200px',
                    whiteSpace:'normal'//set to normal
                },
                step: 1,
                formatter: function () {//use formatter
                    return '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' + this.value + '</div>';
                }
            },
        },
        series: [{
            //name: 'Project 1',
            // pointPadding: 0,
            // groupPadding: 0,
            //borderColor: 'gray',
            pointWidth: 10,
            turboThreshold: 30000,
            boostThreshold: 1,
            /*animation: {
                duration: 10000,
                // Uses Math.easeOutBounce
                easing: 'easeOutBounce'
            },*/
            animation: false,
            dataLabels: {
                enabled: true
            }
        }],
       
        plotOptions: {
            series: {
                borderRadius: '0px',
                borderColor: 'transparent',
                pointWidth: 10,
                turboThreshold: 30000,
                boostThreshold: 1,
                grouping: false
            }
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false,
        }
    }

    setHoverDataBar = (e) => {      
        const { x, x2, y, series, yCategory } = e.target 
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    setClickDataBar = (e) => {         
        const { x, x2, y, series, yCategory } = e.point     
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        this.setState({
            point: point,
            modalOpen: true,
            modalClose : false
        })
        //this.props.params.onInfoModal(point, step)
    }

    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }

    static getDerivedStateFromProps(props, state) {
        if (props.params.objective.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.params.objective.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.params.objective.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                prevObjectiveId: props.params.objective.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.params.objective.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.params.objective.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.objective.objetivo_id!== this.props.params.objective.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.params.objective
        const {schedule}=this.state
        const { period, statePeriod, objective } = this.props.params
        const { history } = this.props;
        let sla_rendimiento_ok = parseInt(objective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(objective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(objective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(objective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        var node = 0
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            Promise.all([
                getDetalleDisponibilidadConsolidadaCustom(user, objetivo_id, node, fecha_inicio, fecha_termino, token, schedule)])
                .then(([res1]) => {
                    return Promise.all([res1.json()])
                })
                .then(([res1]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                })
                .catch(err => { 
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    }); 
                });
        } else {
            Promise.all([
                getDetalleDisponibilidadConsolidada(user, objetivo_id, period, node, token)
            ])
                .then(([res1]) => {
                    return Promise.all([res1.json()])
                })
                .then(([res1, res2]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {                          
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                })
                .catch(err => { 
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    }); 
                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {  

            try {
                const { Nodo, Objetivo_Nombre, Monitores, Global} = externalData.Objetivo
                const { estado } = Global[0]
                let lastEventDict = []
                let arrayChartDataStackedBar = [] 
         
                if (period === 'h') {
                    lastEventDict['namePeriod'] = 'Rango: última hora'
                } else if (period === 'd') {
                    lastEventDict['namePeriod'] = 'Rango: último día'
                } else if (period === 'w') {
                    lastEventDict['namePeriod'] = 'Rango: última semana'
                } else if (period === 'c') {
                    lastEventDict['namePeriod'] = 'Rango: ' + fecha_inicio + ' a ' + fecha_termino
                }
            
                let arrayChartDataStackedBarConsolidated = []
                const colors = ['#41B900', '#C2272D', '#A9A9A9', '#FFC600', '#1976d2'];     
               
                let dictDataStackedBarUptime = {}
                dictDataStackedBarUptime['name'] = 'Uptime'
                dictDataStackedBarUptime['pointWidth'] = 40
                let arrayDataUptime = []
        
                let dictDataStackedBarDowntime = {}
                dictDataStackedBarDowntime['name'] = 'Downtime'
                dictDataStackedBarDowntime['pointWidth'] = 40
                let arrayDataDowntime = []
        
                let dictDataStackedBarNoMon = {}
                dictDataStackedBarNoMon['name'] = 'No Monitoreo'
                dictDataStackedBarNoMon['pointWidth'] = 40
                let arrayDataNoMon = []
        
                let dictDataStackedBarPartial = {}
                dictDataStackedBarPartial['name'] = 'Downtime Parcial'
                dictDataStackedBarPartial['pointWidth'] = 40
                let arrayDataPartial = []
        
                let dictDataStackedBarEvent = {}
                dictDataStackedBarEvent['name'] = 'Mantenimiento'
                dictDataStackedBarEvent['pointWidth'] = 40
                let arrayDataEvent = []
        
                //Diccionarios y listas para información por nodos
                let dictDataStackedBarUptimeNode = {}
                dictDataStackedBarUptimeNode['name'] = 'Uptime'
                dictDataStackedBarUptimeNode['pointWidth'] = 20
                let arrayDataUptimeNode = []
        
                let dictDataStackedBarDowntimeNode = {}        
                dictDataStackedBarDowntimeNode['name'] = 'Downtime'
                dictDataStackedBarDowntimeNode['pointWidth'] = 20
                let arrayDataDowntimeNode = []
        
                let dictDataStackedBarNoMonNode = {}
                dictDataStackedBarNoMonNode['name'] = 'No Monitoreo'
                dictDataStackedBarNoMonNode['pointWidth'] = 20
                let arrayDataNoMonNode = []
        
                let dictDataStackedBarPartialNode = {}
                dictDataStackedBarPartialNode['name'] = 'Downtime Parcial'
                dictDataStackedBarPartialNode['pointWidth'] = 20
                let arrayDataPartialNode = []
        
                let dictEventClient = {}
                dictEventClient['name'] = 'Mantenimiento'
                dictEventClient['pointWidth'] = 20
                let arrayEventClient= []
                
        

                Object.keys(estado).map((key) => {
                    let dictDataStackedBar = {}
        
                    let dateJson = new Date(estado[key]['fecha_desde'].substring(0, 19))
                    let year = dateJson.getFullYear()
                    let month = dateJson.getMonth()
                    let day = dateJson.getDate()
                    let hours = dateJson.getHours()
                    let minutes = dateJson.getMinutes()
                    let seconds = dateJson.getSeconds()
        
                    let dateJsonEnd = (new Date(estado[key]['fecha_hasta'].substring(0, 19)))
                    let yearEnd = dateJsonEnd.getFullYear()
                    let monthEnd = dateJsonEnd.getMonth()
                    let dayEnd = dateJsonEnd.getDate()
                    let hoursEnd = dateJsonEnd.getHours()
                    let minutesEnd = dateJsonEnd.getMinutes()
                    let secondsEnd = dateJsonEnd.getSeconds()
        
                    dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
                    dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
                    dictDataStackedBar['y'] = 0
                    if (estado[key]['nombre'] == 'uptime') {
                        dictDataStackedBar['color'] = colors[0]
                        arrayDataUptime.push(dictDataStackedBar)
                    } else if (estado[key]['nombre'] == 'downtime') {
                        dictDataStackedBar['color'] = colors[1]
                        arrayDataDowntime.push(dictDataStackedBar)
                    } else if (estado[key]['nombre'] == 'no monitoreo') {
                        dictDataStackedBar['color'] = colors[2]
                        arrayDataNoMon.push(dictDataStackedBar)
                    } else if (estado[key]['nombre'] == 'downtime parcial') {
                        dictDataStackedBar['color'] = colors[3]
                        arrayDataPartial.push(dictDataStackedBar)
                    } else if (estado[key]['nombre'] == 'evento cliente') {
                        dictDataStackedBar['color'] = colors[4]
                        arrayDataEvent.push(dictDataStackedBar)
                    }
                })
        
                let categoriedNode = []
                Object.keys(Nodo).map((keyNode) => {        
                    let estadoNodo = Nodo[keyNode][0]['estado']
                    categoriedNode.push(Nodo[keyNode][0]['nodo_nombre'])
        
                    Object.keys(estadoNodo).map((key) => {               
                        let dictDataStackedBar = {}
                        
                        let dateJson = (new Date(estadoNodo[key]['fecha_desde']))
                        let year = dateJson.getFullYear()
                        let month = dateJson.getMonth()
                        let day = dateJson.getDate()
                        let hours = dateJson.getHours()
                        let minutes = dateJson.getMinutes()
                        let seconds = dateJson.getSeconds()
        
                        let dateJsonEnd = (new Date(estadoNodo[key]['fecha_hasta']))
                        let yearEnd = dateJsonEnd.getFullYear()
                        let monthEnd = dateJsonEnd.getMonth()
                        let dayEnd = dateJsonEnd.getDate()
                        let hoursEnd = dateJsonEnd.getHours()
                        let minutesEnd = dateJsonEnd.getMinutes()
                        let secondsEnd = dateJsonEnd.getSeconds()
        
                        dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
                        dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
                        dictDataStackedBar['y'] = parseInt(keyNode) 
                        if (estadoNodo[key]['nombre'] == 'uptime') {
                            dictDataStackedBar['color'] = colors[0]
                            arrayDataUptimeNode.push(dictDataStackedBar)
                        } else if (estadoNodo[key]['nombre'] == 'downtime') {
                            dictDataStackedBar['color'] = colors[1]
                            arrayDataDowntimeNode.push(dictDataStackedBar)
                        } else if (estadoNodo[key]['nombre'] == 'no monitoreo') {
                            dictDataStackedBar['color'] = colors[2]
                            arrayDataNoMonNode.push(dictDataStackedBar)
                        } else if (estadoNodo[key]['nombre'] == 'downtime parcial') {
                            dictDataStackedBar['color'] = colors[3]
                            arrayDataPartialNode.push(dictDataStackedBar)
                        }else if (estadoNodo[key]['nombre'] == 'evento cliente') {
                            dictDataStackedBar['color'] = 'blue'
                            arrayEventClient.push(dictDataStackedBar)
                        }
                        
                    })
                })
                dictDataStackedBarUptime['data'] = arrayDataUptime
                dictDataStackedBarDowntime['data'] = arrayDataDowntime
                dictDataStackedBarNoMon['data'] = arrayDataNoMon
                dictDataStackedBarPartial['data'] = arrayDataPartial
                dictDataStackedBarEvent['data'] = arrayDataEvent
        
                dictDataStackedBarUptimeNode['data'] = arrayDataUptimeNode
                dictDataStackedBarDowntimeNode['data'] = arrayDataDowntimeNode
                dictDataStackedBarNoMonNode['data'] = arrayDataNoMonNode
                dictDataStackedBarPartialNode['data'] = arrayDataPartialNode
                dictEventClient['data'] = arrayEventClient
        
                let heightNodeChart = 200
                if (Nodo.length < 3) {
                    heightNodeChart = 150
                } else if(Nodo.length > 5 && Nodo.length < 10) {
                    heightNodeChart = 500
                } else if(Nodo.length > 10) {
                    heightNodeChart = 900
                } 

                this.setState({
                    chartOptionsStackedBarConsolidated: {
                        chart: {
                            type: 'xrange',
                            height: 120
                        },
                        title: {
                            text: ""
                        },
                        credits: {
                            enabled: false
                          },
                          
                        pane: {
                            size: '100%',
                        },
                        yAxis: { 
                            categories: ['Consolidado'],
                            title: {
                                text: ''
                            },
                            labels: {
                                useHTML:true,
                                style:{
                                    whiteSpace:'normal'
                                },
                                step: 1
                                
                            },
                        },                
                
                        series: [
                                dictDataStackedBarUptime, 
                                dictDataStackedBarDowntime,
                                dictDataStackedBarNoMon, 
                                dictDataStackedBarPartial, 
                                dictDataStackedBarEvent
                            ],
                        plotOptions: {
                            series: {
                                borderRadius: '0px',
                                borderColor: 'transparent',
                                datalabels: false,
                                turboThreshold: 30000,
                                boostThreshold: 1,
                                cursor: 'pointer',
                                point: {
                                    events: {
                                        mouseOver: this.setHoverDataBar.bind(this),
                                        click: this.setClickDataBar.bind(this)
                                    }
                                }
                            },
                            xrange: {
                                dataLabels: {
                                    enabled: false
                                },
                                borderRadius: 0,
                                grouping: false,
                                borderWidth: 0,
                                pointPadding: 0,
                                borderColor: 'none'
                            },
                        },
                        legend: {
                            enabled: false
                        },
                        xAxis: {
                            labels: {
                                enabled: false
                            },
                            visible: false
        
                        },
                        
                        
                    },
                    chartOptionsStackedBarNode: {
                        //yAxis: { categories: ['isp1', 'isp2', 'isp3', 'isp4','isp5']}, 
                        
                        yAxis: { categories: categoriedNode}, 
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                turboThreshold: 30000,
                                boostThreshold: 1,
                                point: {
                                    events: {
                                        mouseOver: this.setHoverDataBar.bind(this),
                                        click: this.setClickDataBar.bind(this)
                                    }
                                }
                            },
                            xrange: {
                                dataLabels: {
                                    enabled: false
                                },
                                borderRadius: 0,
                                grouping: false,
                                borderWidth: 0,
                                pointPadding: 0,
                                borderColor: 'none'
                            },
                        },
                        series: [dictDataStackedBarUptimeNode, dictDataStackedBarDowntimeNode, dictDataStackedBarNoMonNode, dictDataStackedBarPartialNode, dictEventClient],
                        legend: {
                            enabled: false
                        },
                        xAxis: {
                            labels: {
                                enabled: true
                            },
                            visible: true
        
                        },
                        chart: {
                            height: heightNodeChart
                            
                        },
                    },
                    dataError: false,
                    isLoading: false,
                    lastEvent: lastEventDict,
                    time: period,
                    monitores: Monitores,
                    chartOptionsBase: {
                        ...this.state.chartOptionsBase,
                        yAxis: {...this.state.chartOptionsBase.yAxis, categories: categoriedNode},
                        series: [dictDataStackedBarUptimeNode, dictDataStackedBarDowntimeNode, dictDataStackedBarNoMonNode, dictDataStackedBarPartialNode, dictEventClient],
                        legend: {enabled: false},
                        pane: {size: '%100'},
                        plotOptions:{
                            series: {
                                turboThreshold: 30000,
                                boostThreshold: 1,
                                stacking: ""
                                },
                            xrange: {
                                dataLabels: {
                                    enabled: false
                                },
                                borderRadius: 0,
                                grouping: false,
                                borderWidth: 0,
                                pointPadding: 0,
                                borderColor: 'none'
                            },
                        }
                    }
                });

            }catch(err){
                this.setState({
                    dataError: true,
                    data: null,
                    isLoading: false
                });
            }
       

    }
    render() {
        const { classes, className, location } = this.props;
        const {nameNode, dataError, chartOptionsStackedBarConsolidated, chartOptionsStackedBarNode, isLoading, modalOpen, modalClose, currentObjectiveId, point, monitores,chartOptionsBase} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
   
        if (!dataError) {
            sessionStorage.setItem("chartAvailabilityConsolidated",JSON.stringify(chartOptionsBase))
            sessionStorage.setItem("ConsolidatedCategorie",JSON.stringify(chartOptionsStackedBarConsolidated.yAxis.categories))
            sessionStorage.setItem("ConsolidatedSeries",JSON.stringify(chartOptionsStackedBarConsolidated.series))
            // sessionStorage.setItem("chartOptionsStackedBarConsolidated",JSON.stringify(chartOptionsStackedBarConsolidated))
            return (<FormattedChart chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} 
                                    chartOptionsStackedBarNode={chartOptionsStackedBarNode} style={style} 
                                    styleHidden={styleHidden} modalOpen={modalOpen} modalClose={this.setCloseModal} 
                                    classes={classes} objective={currentObjectiveId}
                                    point={point}
                                    monitores={monitores}/>
                                    )
        }
        else if (dataError) {
            let noData = false
            sessionStorage.setItem("chartAvailabilityConsolidated",noData)
            return (<p>No hay datos..</p>)
        }
        else return (<p>Error!</p>)

    }
}

function FormattedChart(props) {
    sessionStorage.setItem("chartOptionsStackedBarConsolidated",JSON.stringify(props.chartOptionsStackedBarConsolidated))
    
    return (
        <div >
            <div style={props.styleHidden}>
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"
                        size={24}
                        thickness={4}
                        />
                        <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style}>
                <PerfectScrollbar>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarConsolidated} />
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarNode} />
                </PerfectScrollbar>
            </div>
            
        </div>
    )
}

export default compose(withRouter, withStyles(styles))(AvailabilityConsolidatedSimplified);